import React from 'react'
import Header from './components/header'

export default ({ children, initialState }) => (
  <html>
    <head>
      <meta httpEquiv="Content-type" content="text/html; charset=utf-8"/>
      <meta charSet="utf-8" />
      <title>DA Login</title>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
      <link rel="stylesheet" href="https://static.da-io.net/democratic-style/bs4/assets/css/core.min.css" type="text/css" media="all"/>
      <link href='https://fonts.voteda.org/css?family=Open+Sans:400,300,600%7CMontserrat:400,700' rel='stylesheet' type='text/css'/>
      <link rel="shortcut icon" href="https://static.da-io.net/favicon.ico"/>
      <script dangerouslySetInnerHTML={{__html: initialState}} />
    </head>
    <body>
      <Header />
      { children }
      <script src="../bundled/bundle.js"></script>
    </body>
  </html>
)



// WEBPACK FOOTER //
// ./src/app/app.js